import React, { Component } from 'react';
import { getFileName } from 'helpers/FileCaching';
import classes from './GoldSocialIcon.module.scss';
import Transition from 'react-transition-group/Transition'
import FacebookIcon from 'components/App/SocialIcons/FacebookIcon/FacebookIcon';
import TwitterIcon from 'components/App/SocialIcons/TwitterIcon/TwitterIcon';
const goldSocialIcon = require.context('images/components/Articles/Article/GoldSocialIcon', true, /.*\.(gif|png|jpe?g|svg)$/i);


class GoldSocialIcon extends Component {

    constructor(props){

        super(props);

        this.state = {
          isImageView: false,
          showBlock:false
        }
     
        this.handleClick = this.handleClick.bind(this);

    }
    
    handleClick() {
      this.setState(prevState => ({ showBlock: !prevState.showBlock }));
    }

    render(){
      const duration = 200;
      const animationTiming ={
        enter: 200,
        exit:300
      }
      
      const animationTimingTwo ={
        enter: 400,
        exit:300
      }

      let defaultStyle = {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      }

      let transitionStyles = {
        entering: { opacity: 0 },
        entered:  { opacity: 1 },
      };
   
  return (
      <div className={classes.goldenSocialIcon}>
        <div className={classes.goldenSocialIcon__BtnContainer}> 
          <div className={classes.goldenSocialIcon__mainBTN} onClick={() => 
            this.setState(prevState => ({showBlock: !prevState.showBlock})) }>  
            <IconButton/>
          </div>
        </div>
        <div className={classes.goldenSocialIcon__contaniner_open}>
          <Transition 
            in={this.state.showBlock} 
            appear={true}
            timeout={animationTimingTwo}
            mountOnEnter
            unmountOnExit
            >
            {state => (
                <div style={{
                  transition: 'all .3s ease-in-out',
                  ...defaultStyle,
                  ...transitionStyles[state]
                  }}>
                    <TwitterIcon twitterDescription={this.props.content['description-twitter']} twitterDescriptionHashtag={this.props.content['description-twitter-hashtags']} url={this.props.url}/>
                </div> 
            )}
            </Transition>
            <Transition 
              in={this.state.showBlock} 
              appear={true}
              timeout={animationTiming}
              mountOnEnter
              unmountOnExit
              >
              {state => (
                  <div style={{
                    transition: 'all .3s ease-in-out 1s',
                    ...defaultStyle,
                    ...transitionStyles[state]
                    }}>
                      <FacebookIcon facebookDescription={this.props.content.og_meta['description-facebook']} url={this.props.url} />
                  </div> 
              )}
            </Transition>
          </div>    
      </div>
  );

}
    
}

class IconButton extends React.Component { 
  constructor(props) {
    super(props);
    this.state = {
      isImageView: false,
    }
  } 
  
  render() {

    return (
      <a onClick={()=>this.setState({ isImageView: !this.state.isImageView })}>
        { this.state.isImageView
          ?  <img src={getFileName(goldSocialIcon, 'share-icon-close.svg')} alt="share"/>
          :  <img src={getFileName(goldSocialIcon, 'share-icon-open.svg')} alt="share"/>
        }
      </a>
    );
  }
  
}






export default GoldSocialIcon;